

import axiosInstance from '../../axios.config';
import { useEffect, useState } from "react"
import { toast } from 'react-toastify';

export const useCoursesCertificatesStatusMap = (courses, userId) => {
    const [certificateStatusMap, setCertificateStatusMap] = useState({});

    useEffect(() => {
        if (!Array.isArray(courses) || !courses?.length || !userId) return;
        (async () => {
            const coursesIds = courses.map(x => x.courseID);
            const statusMap = await checkCertificatesExistence(userId, coursesIds)
            setCertificateStatusMap(statusMap)
        })();


    }, [courses, userId])

    return {
        certificateStatusMap
    }
}

const checkCertificatesExistence = async (userId, courseIds) => {
    try {
        const response = await axiosInstance.get('/Certificate/CheckCertificatesExistence', {
            params: {
                userId: userId,
                coursesIds: courseIds
            },
            paramsSerializer: {
                indexes: null
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error calling CheckCertificatesExistence API:', error);
        throw error;
    }
};


export const checkCertificateAvailability = async (courseID, userid) => {
    try {
        const response = await axiosInstance.get(`/Certificate/getcertificate?UserID=${userid}&courseID=${courseID}`);
        return response.data.length > 0; // Check if there are certificates
    } catch (error) {
        console.error('Error checking certificate availability', error);
        return false; // Default to false on error
    }
};

export const handleCertificateDownload = (courseID, userid, userfname, userlname) => {
    axiosInstance
        .get(`/Certificate/getcertificate?UserID=${userid}&courseID=${courseID}`, {
            responseType: 'blob', // Ensure file download
        })
        .then((response) => {

            // Check if the response is empty or contains an error status indicating no certificate
            if (response.data.size === 0) {
                toast.error("No certificate available for download.");
                return;
            }
            // Create a URL for the downloaded file blob
            const blob = new Blob([response.data], { type: response.data.type });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Try to retrieve filename from Content-Disposition header
            const contentDisposition = response.headers['content-disposition'];
            let fileName = `${userfname}_${userlname}_Certificate.png`;  // Fallback name in case server doesn't provide it

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                if (fileNameMatch && fileNameMatch.length > 1) {
                    fileName = fileNameMatch[1];
                }
            }

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url); // Clean up after download
        })
        .catch((error) => {
            if (error.response && error.response.status === 404) {
                toast.error("No certificate found for this course.");
            } else {
                toast.error("Error downloading certificate.");
            }
            console.error('Error downloading certificate', error);
        });
};
